// src/views/Components/Chat/mockData.js

export const contacts = [
  {
    id: 1,
    name: "Alice Johnson",
    avatar: "https://i.pravatar.cc/150?img=1",
    lastMessage: "Hey, how are you?",
    messages: [
      { id: 1, text: "Hey, how are you?", fromMe: false },
      { id: 2, text: "I'm good! You?", fromMe: true },
    ],
  },
  {
    id: 2,
    name: "Bob Smith",
    avatar: "https://i.pravatar.cc/150?img=2",
    lastMessage: "Did you check the file?",
    messages: [{ id: 1, text: "Did you check the file?", fromMe: false }],
  },
];
